export default __webpack_public_path__ + "static/media/pages.28a4d3c2.svg";